<template>
    <div class="borda">
        <ValidationObserver ref="observer">
            <v-row align="center" class="pt-6">
                <v-col cols="12" md="4" class="py-1">
                    <div>
                        Parâmetro:
                    </div>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                        <input-cadu
                            disabled
                            :value="parametro"
                        />
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" md="4" class="py-1">
                    <div>
                        Percentual:
                    </div>
                </v-col>
                <v-col cols="12" md="2" class="py-1 pr-1" style="flex: 0 0 11.666667%; max-width: 11.666667%;">
                    <validation-provider name="area" mode="eager" rules="required|numeric|max:3" v-slot="{ errors }">
                        <input-cadu
                            :errorMessage="errors[0]"
                            :disabled="editar"
                            mask="###"
                            v-model="percentual"
                        />
                    </validation-provider>
                </v-col>
                <v-col cols="auto" class="pl-0 py-1 pr-2" align-self="center">
                    %
                </v-col>
                <v-col class="py-1 pl-0" align-self="center">
                    <button-rounded iconName="edit" :iconSize="16" @click="editar = false"/>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col cols="12" md="4" class="py-1" >
                    <div>
                        Status:
                    </div>
                </v-col>
                <v-col cols="1" class="pr-0">
                    {{status ? 'Ativa': 'Inativa'}}
                </v-col>
                <v-col cols="auto" class="py-1">
                    <switch-cadu v-model="status" />
                </v-col>
            </v-row>
            <v-row justify="end">
                <v-col cols="auto" class="py-1">
                    <button-cadu @click="salvar">
                        SALVAR
                    </button-cadu>
                </v-col>
            </v-row>
        </ValidationObserver>
        <overlay-loading v-model="loadingOverlay"/>
        <error-modal
            v-model="showError"
            :errObj="errObj"
        />
        <SucessoModal
            :genericMessage="'Parâmetro atualizado com sucesso'"
            :showSucess="showSucess"
            @close="showSucess = false"
        />
    </div>
</template>

<script>
import ParametrosGerais from '@/services/ParametrosGerais/ParametrosGerais'
import ErrorMixin from '@/Mixins/ErrorMixin'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  mixins: [ErrorMixin],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      parametro: '',
      percentual: '',
      status: false,
      parametroPadrao: 'PORCENTAGEM_PERFIL',
      config: '',
      parametrosGerais: '',
      loadingOverlay: false,
      editar: true,
      showSucess: false
    }
  },
  created () {
    this.parametrosGerais = new ParametrosGerais(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
    this.loadingFunc(this.getInformacoes())
  },
  methods: {
    async loadingFunc (...func) {
      this.loadingOverlay = true
      await Promise.all(func)
        .finally(() => {
          this.loadingOverlay = false
        })
    },
    async promiseGeneric (className, nomeFunc, ...valoresFunc) {
      try {
        return await className[nomeFunc](...valoresFunc)
      } catch (err) {
        this.setError(err)
      }
    },
    async getInformacoes () {
      let informacoes = await this.promiseGeneric(this.parametrosGerais, 'getParametroSimples', this.parametroPadrao)
      informacoes = informacoes.data
      this.parametro = informacoes.nome
      this.percentual = informacoes.valor
      this.status = informacoes.ativo
    },
    async salvar () {
      const valid = this.$refs.observer.validate()
      if (valid) {
        const obj = {
          'ativo': this.status,
          'codigo': 'PORCENTAGEM_PERFIL',
          'nome': this.parametro,
          'valor': this.percentual
        }
        await this.loadingFunc(this.promiseGeneric(this.parametrosGerais, 'putParametroSimples', obj))
        this.showSucess = true
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.borda
    border: 1px solid #00995d
    border-radius: 10px
    padding: 10px
</style>
